import React, { useState, useEffect } from 'react';
import { APP_URL } from 'types';
import { SideNavLink } from 'carbon-components-react/lib/components/UIShell';
import { Building16, Events16 } from '@carbon/icons-react';
import { useHistory } from 'react-router-dom';

export const LeftNavCommonMenuItem: React.FC<Props> = ({ disableNav }) => {
  const history = useHistory();
  const [pathname, setPathname] = useState<string>(history?.location?.pathname);

  useEffect(() => {
    history && setPathname(history.location?.pathname);
  }, [history]);
  return (
    <>
      <SideNavLink
        aria-disabled={disableNav}
        aria-current={
          pathname.match(new RegExp(`^${APP_URL.SYSADMIN_ORG}`))
            ? 'page'
            : undefined
        }
        renderIcon={Building16}
        onClick={
          disableNav ? undefined : () => history.push(`${APP_URL.SYSADMIN_ORG}`)
        }
      >
        Organisations
      </SideNavLink>
      <SideNavLink
        aria-disabled={disableNav}
        aria-current={
          pathname === APP_URL.SYSADMIN_FREE_PLAN ? 'page' : undefined
        }
        renderIcon={Events16}
        className="add-icon"
        onClick={
          disableNav
            ? undefined
            : () => history.push(`${APP_URL.SYSADMIN_FREE_PLAN}`)
        }
      >
        Free plan users
      </SideNavLink>
    </>
  );
};

type Props = {
  disableNav?: boolean;
};

export default LeftNavCommonMenuItem;
